module.exports = __webpack_public_path__ + "static/media/microverse-themed-restaurant.7849efe7.png";